<template>
    <div class="w-full h-full flex flex-col p-6 lg:p-10 bg-gray-100">
        <div class="w-full h-full">
            <div class="w-full flex flex-col justify-center items-start mb-5 gap-1">
                <p class="text-gray-400 text-sm"><span @click="$router.push('/services')"
                        class="hover:underline cursor-pointer">Services</span> / Electronic Fund Transfer</p>
                <h1 class="text-theme-primary text-3xl font-semibold">Electronic Fund Transfer</h1>
            </div>


            <div class="rounded w-full bg-white p-5">
                <div v-if="has_read_tnc && bankList.length > 0 && !show_loader" class="flex flex-col lg:flex-row items-start lg:items-center justify-between text-left mb-5 gap-3">
                    <p class="px-3 text-gray-600 font-medium text-lg border-l-8 border-theme-secondary">Registered
                        Bank Accounts</p>
                    <p class="font-medium text-gray-400 cursor-pointer" @click="tnc_modal = true">Read <span class="underline">Terms and Conditions</span></p>
                </div>

                <SkeletonControl v-show="show_loader" class="mt-5" />
                <div v-show="!show_loader && eft_close && ((bankList.length > 0 && !has_read_tnc) || bankList.length === 0)"
                    class="font-medium space-y-3 text-xs lg:text-sm leading-5 text-justify rounded w-full bg-blue-100 border-l-8 border-theme-info-default text-blue-900 p-5">
                    <p>Thank you for your interest in applying for the EFT for your Patronage Refund and Interest in
                        Share Capital (Dividend).</p>
                    <p>However, Electronic Fund Transfer for Dividends scheduled for February 2026 will be <b
                            class="uppercase">postponed</b> until further notice. The application for EFT‑Patronage
                        Refund is expected to reopen later this year.</p>
                    <p>Kindly wait for further announcements here in the membership portal and through our official
                        channels.</p>
                    <p>We appreciate your patience and understanding.</p>
                </div>
                <div v-show="!show_loader">
                    <!--Has No Bank-->
                    <div v-if="bankList.length === 0 && has_read_tnc && !eft_close"
                        class="border-gray-200 border-2 rounded-lg flex flex-col items-center justify-center p-5">
                        <img src="@/assets/images/papsi_empty.png" class="w-16 opacity-75 mb-2">
                        <p class="font-medium text-gray-600 text-lg px-0 sm:px-8 md:px-16 lg:px-32">No bank account is
                            enrolled under your PAFCPIC Account.</p>
                        <p class="text-sm lg:text-base text-gray-500 px-0 sm:px-8 md:px-16 lg:px-32 mt-2">Right now,
                            only PNB accounts opened
                            through PSOs are supported. For members who opened their PNB accounts through other
                            channels,
                            please stay tuned—your accounts will be included in the next phase of our system
                            integration. If you
                            haven’t opened your PNB account yet, please visit your nearest PSO to apply while cards are
                            still free.</p>
                    </div>
                    <!--Has Bank-->
                    <div v-if="(has_read_tnc || eft_close) && bankList.length > 0 && has_read_tnc">
                        <div v-for="bank in bankList" :key="`${bank.bank_key}-${bank.bank_act_no}`"
                            class="border-gray-200 border-2 rounded-lg flex flex-col p-5 mb-4">
                            <div class="flex flex-row items-center justify-between">
                                <div class="flex flex-row space-x-3 items-center ">
                                    <img src="https://resource.pafcpic.net/assets/logo/pnb_papsi.png" class="w-8">
                                    <div class="text-gray-600">
                                        <p class="font-medium text-sm lg:text-lg">{{ bank.bank_name }}</p>
                                        <div class="flex flex-row items-center space-x-2">
                                            <p class="text-xs lg:text-base">
                                            {{ maskBankNo(bank.bank_act_no, bank.visible) }}
                                            </p>

                                            <img
                                            @click="bank.visible = !bank.visible"
                                            :src="bank.visible
                                                ? require('@/assets/images/papsi_vis_icon.svg')
                                                : require('@/assets/images/papsi_invi_icon.svg')"
                                            class="w-5 h-5 cursor-pointer">
                                        </div>
    
                                    </div>
                                </div>
    
                            </div>
    
                            <transition name="dropdown">
                                <div v-if="bank.dropdown_collapse" class="w-full mt-4 flex flex-col space-y-4">
                                    <!-- <div v-for="sub in subscriptions" :key="sub.subscription_key" -->
                                    <div v-for="sub in bank.member_subcription.filter(s => s.subscription_key !== 'SVC0000002')"
                                        :key="sub.subscription_key"
                                        class="flex flex-col lg:flex-row justify-between items-start lg:items-center rounded-xl bg-gray-100 p-3 lg:p-5">
                                        <div class="flex flex-col">
                                            <p class="font-medium">{{ sub.subscription_name.replace('EFT - ', '') }}</p>
                                            <p class="text-xs lg:text-sm text-gray-500">Receive your {{
                                                sub.subscription_name.replace('EFT - ', '') }} via EFT</p>
                                        </div>
                                        <div class="flex flex-row items-center justify-center gap-2 lg:gap-4">
                                            <p 
                                                class="font-medium order-2 lg:order-1"
                                                :class="sub.subscription_status ? 'text-theme-primary' : 'text-gray-500'"
                                                >
                                                {{ sub.subscription_status ? 'Subscribed' : 'Unsubscribed' }}
                                            </p>

                                            <ToggleControl
                                                :model-value="sub.subscription_status"
                                                @update:modelValue="onToggleBankSubscription(bank, sub, $event)"
                                                class="mt-2 lg:mt-0 order-1 lg:order-2"
                                                :class="[eft_close ? 'opacity-25 cursor-not-allowed' : '']"
                                            />
                                        </div>
                                    </div>
    
                                    <div v-show="!eft_close"
                                        class="w-full text-right mt-5 flex flex-col lg:flex-row justify-end space-x-0 lg:space-x-3 items-center">
                                        <!-- <Button :button_text="toggleAllLabel" is_secondary @clicked="toggleAll"
                                            class="w-full lg:w-1/4" /> -->
                                        <Button :button_text="'Save Changes'" :theme="'text-white'" :disabled="!hasBankChanges(bank)"
                                            @clicked="saveBankSubscriptions(bank)" class="w-full lg:w-1/4 mt-4 lg:mt-0" />
                                    </div>
                                </div>
                            </transition>
    
                        </div>
                    </div>
                    <!--Terms and Conditions-->
                    <div v-if="!has_read_tnc && !eft_close"
                        class="w-full flex flex-col text-xl justify-start text-left items-end space-y-6">
                        <EFTTermsView />
                        <div class="w-full flex justify-end space-x-3 mt-6 lg:w-[30%] text-right items-end">
                            <Button :button_text="'I Agree'" :theme="'bg-theme-primary text-white'"
                                @clicked="closeTerms" />
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <ModalControl v-show="show_pin_modal" v-bind:display="show_pin_modal" z_value="z-40" closable
            @closed="show_pin_modal = false; show_subscribe_modal = true;" id='pin_modal' :default_width="'max-w-lg'">
            <div class="pt-6">
                <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-left">PIN Verification</h2>
                <p class="mb-5 text-left text-base">Please enter your Personal Identification Number (PIN) to proceed.
                </p>

                <div class="w-full flex flex-row justify-center my-4">
                    <v-otp-input :is-disabled="false" ref="pinOTP" input-classes="otp-input" :input-type="pin_type"
                        inputmode="numeric" :num-inputs="6" v-model:value="pin_value" :should-auto-focus="true"
                        :should-focus-order="true" :key="otpInputKey" @on-complete="validatePIN"
                        @on-change="changePIN" />
                    <div class="otp-input flex justify-center items-center text-center bg-gray-100 cursor-pointer"
                        @click="togglePeeker()">
                        <Icon :source="getImgSrc()" :width="24" />
                    </div>
                </div>

                <div v-if="pin_error_message" class="w-full flex items-center justify-center text-center mt-3">
                    <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium text-base"
                        v-text="pin_error_message" />
                </div>
            </div>
        </ModalControl>

        <ModalControl v-show="showCloseModal && bankList.length > 0 && has_read_tnc && !show_loader && eft_close"
            v-bind:display="showCloseModal && bankList.length > 0 && has_read_tnc && !show_loader" :note="true"
            :question="this.question" z_value="z-50" @positiveClick="closeEFTModal" :positiveButton="'OK'"
            :default_width="'max-w-xl'" id='vote_modal'>
            <div class="w-full px-5 pt-2 pb-4 flex flex-col text-justify items-start text-base lg:text-lg space-y-3">
                <p>Thank you for your interest in applying for the EFT for your Patronage Refund and Interest in Share
                    Capital (Dividend).</p>

                <p>However, Electronic Fund Transfer for Dividends scheduled for February 2026 will be <b
                        class="uppercase">postponed</b> until further notice. The application for EFT‑Patronage Refund
                    is expected to reopen later this year.</p>
                <p>Kindly wait for further announcements here in the membership portal and through our official
                    channels.</p>
                <p>We appreciate your patience and understanding.</p>

            </div>
        </ModalControl>

        <ModalControl v-show="show_message_modal" v-bind:display="show_message_modal" :error="this.error"
            :success="this.success" :note="this.warning" :question="this.question" z_value="z-50"
            @positiveClick="handlePositiveClick()" :positiveButton="'OK'" :default_width="'max-w-xl'" id='vote_modal'>
            <div class="w-full px-5 pt-2 pb-4 flex flex-col text-xl justify-center text-center items-center">
                {{ this.modal_message }}
            </div>
        </ModalControl>

        <ModalControl v-show="terms_modal" v-bind:display="terms_modal" z_value="z-50" closable
            @closed="terms_modal = false" :default_width="'max-w-4xl'" id='eft_modal'>
            <div class="w-full pt-6 flex flex-col text-xl justify-start text-left items-start space-y-6">
                <EFTTermsView />

                <div class="w-full flex justify-end space-x-3 mt-6">
                    <Button :button_text="'Cancel'" is_secondary
                        @clicked="terms_modal = false; pendingSubscription = null;" />
                    <Button :button_text="'Agree'" :theme="'bg-theme-primary text-white'" @clicked="agreeToTerms" />
                </div>
            </div>
        </ModalControl>
        
        <ModalControl v-show="tnc_modal" v-bind:display="tnc_modal" z_value="z-50" closable
            @closed="tnc_modal = false" :default_width="'max-w-4xl'" id='eft_modal'>
            <div class="w-full pt-6 flex flex-col text-xl justify-start text-left items-start space-y-6">
                <EFTTermsView />
            </div>
        </ModalControl>





    </div>
</template>

<script>
import { defineComponent } from 'vue';
import ModalControl from '@/components/controls/ModalControl.vue';
import EFTTermsView from '../static/EFTTermsView.vue';
import SkeletonControl from '@/components/controls/SkeletonControl.vue';
// import Checkbox from "@/components/controls/CheckBox.vue";
// import PictureBoxControl from '@/components/controls/PictureBoxControl.vue';
import Button from '@/components/controls/ButtonControl.vue';
import ToggleControl from '@/components/controls/ToggleControl.vue';
import Icon from "@/components/controls/Icon.vue";
import VOtpInput from "vue3-otp-input";
import User from "@/services/User";
import mixin from '@/mixin';

export default defineComponent({
    components: {
        ModalControl,
        // PictureBoxControl,
        ToggleControl,
        // Checkbox,
        SkeletonControl,
        Button,
        Icon,
        VOtpInput,
        EFTTermsView
    },
    mixins: [mixin],
    inject: ['setLoading'],
    data() {
        return {
            showCloseModal: true,
            tnc_modal: false,
            eft_close: false,
            has_read_tnc: true,
            terms_shown_on_load: false,
            show_loader: false,
            dropdown_collapse: true,
            terms_modal: false,
            // show_subscribe_modal: false,
            show_pin_modal: false,
            pin_type: 'password',
            visible_pin: false,
            pin_error_message: '',
            show_message_modal: false,
            modal_message: '',
            success: false,
            warning: false,
            error: false,
            question: false,
            pin_value: '',
            otpInputKey: 0,
            expired: false,
            activeTab: 'form',
            selected: {
                patref: false,
                dividend: false,
                loan: false
            },
            status: null,
            bankList: [],
            subscriptions: [],
            pendingSubscriptions: [],
        }
    },
    mounted() {
        const state = this.$store.state;

        if (!state.credentials.username) {
            this.getUserInfo();
        } else {
            this.checkUserFlow();
        }
    },
    computed: {
        maskedBankNo() {
            const bankNo = this.selectedBank?.bank_act_no;
            if (!bankNo) return '';
            return this.visible_bank ? bankNo : this.maskBankNo(bankNo, true);
        },
        save_btn() {
            return this.subscriptions.some(sub => sub.is_changed);
        },
        allOriginallyOn() {
            // Returns true if all subscriptions were ON originally
            return this.subscriptions.length > 0 &&
                this.subscriptions.every(sub => sub.original_status === 1);
        },
        toggleAllLabel() {
            // If all are currently ON → show "Unsubscribe to All"
            // Otherwise → show "Subscribe to All"
            if (this.subscriptions.length === 0) return "Subscribe to All";
            const allOn = this.subscriptions.every(sub => sub.subscription_status === 1);
            return allOn ? "Unsubscribe to All" : "Subscribe to All";
        },
    },
    methods: {
        closeEFTModal() {
            this.showCloseModal = false;
        },
        closeTerms() {
            this.has_read_tnc = true;
            this.dropdown_collapse = true;
        },
        toggleAll() {
            // Determine if we are turning all ON or OFF
            const allOn = this.subscriptions.every(sub => sub.subscription_status === 1);
            const newStatus = allOn ? 0 : 1;

            // Toggle all subscriptions
            this.subscriptions.forEach(sub => {
                sub.subscription_status = newStatus;
                sub.is_changed = sub.subscription_status !== sub.original_status;
            });
        },
        onToggle(sub, newValue) {
            if (this.eft_close) {
                return;
            }
            sub.subscription_status = newValue ? 1 : 0;
            sub.is_changed = sub.subscription_status !== sub.original_status;
        },
        agreeToTerms() {
            this.terms_modal = false;

             // ✅ Persist locally
            // if (this.selectedBank) {
            //     this.selectedBank.has_read_tnc = true;
            // }
            // this.has_read_tnc = true;

            // Case 1: when user toggled a single subscription ON
            if (this.pendingSubscription) {
                this.show_pin_modal = true;
                this.pin_value = '';
                this.pin_error_message = '';
                this.pendingSubscription = null;
                return;
            }

            // Case 2: when "Save Changes" was clicked (batch update)
            if (this.pendingChanges && this.pendingChanges.length > 0) {
                this.show_pin_modal = true;
                this.pin_value = '';
                this.pin_error_message = '';
            }
        },
        subscribe(sub) {
            if (!sub.subscription_status) {
                // User toggled from OFF → ON
                this.pendingSubscription = sub;
                this.terms_modal = true; // show Terms first
            } else {
                // User toggled from ON → OFF
                sub.subscription_status = false;
            }
        },
        saveSubscriptions() {
            const changedSubs = this.subscriptions.filter(sub => sub.is_changed);

            if (changedSubs.length === 0) {
                this.modal_message = "No changes to update.";
                this.success = false;
                this.warning = true;
                this.error = false;
                this.show_message_modal = true;
                return;
            }

            const hasOffToOn = changedSubs.some(
                sub => sub.original_status === 0 && sub.subscription_status === 1
            );

            this.pendingChanges = changedSubs.map(sub => ({
                subscription_key: sub.subscription_key,
                subscription_status: sub.subscription_status ? 1 : 0,
            }));

            // 🔁 Reversed logic here
            if (hasOffToOn) {
                if (this.$store.state.banks.has_read_tnc) {
                    // ✅ If already read T&C → show Terms first
                    this.terms_modal = true;
                } else {
                    // ✅ If NOT yet read T&C → skip Terms and go straight to PIN modal
                    this.show_pin_modal = true;
                    this.pin_value = '';
                }
            } else {
                // For OFF → OFF or ON → OFF changes, always show PIN modal
                this.show_pin_modal = true;
                this.pin_value = '';
            }
        },
        getToggleIcon() {
            return this.visible_bank
                ? require('@/assets/images/papsi_vis_icon.svg')
                : require('@/assets/images/papsi_invi_icon.svg');
        },
        maskBankNo(bankNo, visible = false) {
            if (!bankNo) return '';
            // Show only last 4 digits, replace the rest with asterisks
            const visiblePart = bankNo.slice(-4);
            const maskedPart = '*'.repeat(bankNo.length - 4);
            return visible ? bankNo : maskedPart + visiblePart;
        },
        hasBankChanges(bank) {
            if (!bank || !bank.member_subcription) return false;
            return bank.member_subcription.some(sub => sub.is_changed);
        },
        onToggleBankSubscription(bank, sub, newValue) {
            if (this.eft_close) {
                return;
            }
            sub.subscription_status = newValue ? 1 : 0;
            sub.is_changed = sub.subscription_status !== sub.original_status;
        },
        saveBankSubscriptions(bank) {
            if (!bank || !bank.member_subcription) return;

            this.selectedBank = bank;
            
            const changedSubs = bank.member_subcription.filter(sub => sub.is_changed);

            if (changedSubs.length === 0) {
                this.modal_message = "No changes to update.";
                this.success = false;
                this.warning = true;
                this.error = false;
                this.show_message_modal = true;
                return;
            }

            const hasOffToOn = changedSubs.some(
                sub => sub.original_status === 0 && sub.subscription_status === 1
            );

            this.pendingChanges = changedSubs.map(sub => ({
                subscription_key: sub.subscription_key,
                subscription_status: sub.subscription_status ? 1 : 0,
            }));


            // 🔁 Reversed logic here
            if (hasOffToOn) {
                if (bank.has_read_tnc) {
                    // ✅ If already read T&C → show Terms first
                    this.terms_modal = true;
                } else {
                    // ✅ If NOT yet read T&C → skip Terms and go straight to PIN modal
                    this.show_pin_modal = true;
                    this.pin_value = '';
                }
            } else {
                // For OFF → OFF or ON → OFF changes, always show PIN modal
                this.show_pin_modal = true;
                this.pin_value = '';
            }
        },
        getBanks() {
            this.show_loader = true;
            User.getBanks()
                .then((response) => {
                    this.show_loader = false;
                    const bankData = response.data.data;
                    const bankList = Array.isArray(bankData)
                        ? bankData
                        : bankData ? [bankData] : [];

                    this.bankList = bankList;

                    // Initialize each bank with UI state
                    this.bankList.forEach(bank => {
                        bank.dropdown_collapse = true;
                        bank.visible = false;
                        if (bank.member_subcription) {
                            bank.member_subcription.forEach(sub => {
                                sub.subscription_status = Number(sub.subscription_status);
                                sub.original_status = sub.subscription_status;
                                sub.is_changed = false;
                            });
                        }
                    });

                    const selectedBank = bankList.find(bank => bank && (bank.bank_acct_s || bank.bank_acct_c)) || bankList[0] || null;
                    this.selectBank(selectedBank);

                    // ✅ If T&C not yet read, show it
                    if (!this.has_read_tnc) {
                        this.terms_shown_on_load = true;
                    }
                })
                .catch((error) => {
                    this.show_loader = false;
                    this.show_message_modal = true;
                    this.modal_message = error.response?.data?.message || 'Unable to load bank accounts.';
                    this.error = true;
                    if (error.response && error.response.status == 403) {
                        this.expired = true;
                        this.modal_message = "Your session has expired. Please log in again.";
                        this.$store.state.logged = false;
                    }
                });
        },
        selectBank(bank) {
            if (!bank) return;
            this.selectedBank = bank;
            this.$store.state.banks = bank;
            this.subscriptions = bank.member_subcription || [];
            this.has_read_tnc = bank.has_read_tnc === true;
        },
        closed() {
            let that = this;

            that.$cookies.remove('user');
            that.$cookies.remove('user_session');
            that.$router.push('/');
            that.show_message_modal = false;
        },
        subscribeBank() {
            if (!this.selectedBank) return;

            // Collect only the subscriptions that have changed
            const changedSubscriptions = this.selectedBank.member_subcription
                .filter(sub => sub.is_changed)
                .map(sub => sub.subscription_key);

            if (changedSubscriptions.length === 0) {
                this.modal_message = "No changes to update.";
                this.success = false;
                this.warning = true;
                this.error = false;
                this.show_message_modal = true;
                return;
            }

            const payload = {
                bank_key: this.selectedBank.bank_key,
                subscription_key: changedSubscriptions,
            };
            const state = this.selectedBank;

            this.setLoading(true);
            User.subscribeEFT(payload, state.bank_acct_c, state.bank_acct_s)
                .then(() => {
                    this.setLoading(false);
                    this.error = false;
                    this.warning = false;
                    this.success = true;
                    this.show_message_modal = true;
                    this.show_pin_modal = false;
                    this.modal_message =
                        "Your EFT subscription updates have been successfully saved!";
                    if (this.selectedBank && this.selectedBank.member_subcription) {
                        this.selectedBank.member_subcription.forEach(sub => {
                            sub.original_status = sub.subscription_status;
                            sub.is_changed = false;
                        });
                    }
                })
                .catch((error) => {
                    let that = this;
                    that.error = true;
                    that.setLoading(false);
                    that.show_message_modal = true;
                    that.modal_message = error.response.data.message;
                    if (error.response.status == 403) {
                        that.expired = true;
                        that.modal_message = "Your session has expired. Please log in again.";
                        that.$store.state.logged = false;
                    }
                });
        },
        agree({ id, value }) {
            console.log(`${id} selected:`, value);
        },
        getImgSrc() {
            return this.visible_pin ? "images/papsi_vis_icon.svg" : "images/papsi_invi_icon.svg";
        },
        togglePeeker() {
            if (this.pin_type == 'password') {
                this.visible_pin = true;
                this.pin_type = 'number';
            } else {
                this.visible_pin = false;
                this.pin_type = 'password';
            }
        },
        changePIN() {
            this.pin_error_message = '';
        },
        handlePositiveClick() {
            if (this.expired) {
                this.closed();
            } else {
                this.show_message_modal = false;
                this.show_pin_modal = false;
                this.pin_value = '';
            }
        },
        validatePIN() {
            let that = this;

            const cookie = that.$cookies;
            let pin_payload = {
                hash: cookie.get('user_session').hash,
                pin: that.pin_value
            }

            that.setLoading(true);
            that.show_message_modal = false;
            that.show_pin_modal = false;
            User.validateOldPin(cookie.get('user').uuid, pin_payload).then(function () {
                that.subscribeBank();

            }).catch(function (error) {
                if (error.response.status === 403) {
                    that.expired = true;
                    that.$store.state.logged = false;
                    that.setLoading(false);
                    that.error = true;
                    that.info = false;
                    that.warning = false;
                    that.success = false;
                    that.show_message_modal = true;
                    that.modal_message = "Your session has expired. Please log in again.";
                }
                that.setLoading(false);
                that.pin_error_message = error.response.data.message;
                that.otpInputKey++;
                that.show_pin_modal = true;
                that.pin_value = '';
            });
        },
        getUserInfo() {
            let that = this;
            const cookie = that.$cookies;
            const store = that.$store;
            let state = store.state;
            that.setLoading(true);

            User.recoverSession(cookie.get('user_session').hash).then(function (response) {
                let data = response.data.data;
                state.logged = true;
                state.credentials.first_name = data.info.first_name;
                state.credentials.last_name = data.info.last_name;
                state.credentials.middle_name = data.info.middle_name;
                state.credentials.regular = data.info.regular;
                state.credentials.express = data.express;
                state.credentials.pso_enroll = data.pso_enroll;
                state.credentials.pin_update = data.pin_update;
                state.credentials.membership_date = data.info.membership_date || null;
                state.credentials.status = data.status || null;
                state.credentials.account_no = data.info.account_number;
                state.gaUser = data.ga;
                state.credentials.email = data.info.email;
                state.credentials.gender = data.info.gender;
                state.credentials.birthdate = data.info.date_of_birth;
                state.credentials.age = data.info.age;
                state.credentials.membership_type = data.info.membership_type;
                state.credentials.registered_date = data.info.registered;
                state.credentials.key = data.key;
                state.credentials.mobile = data.info.mobile;
                state.credentials.name = data.info.first_name + " " + data.info.last_name + (data.info.suffix ? " " + data.info.suffix : "");
                state.credentials.suffix = data.info.suffix ?? '';
                state.credentials.qr = data.qr;
                state.credentials.uuid = data.uuid;
                state.credentials.serial_no = data.info.serial_number;
                state.credentials.timestamp = response.timestamp;
                state.credentials.username = data.info.username;
                state.credentials.hash = data.hash;
                state.credentials.has_pin = data.has_pin;
                state.credentials.deactivated = data.deactivated;
                state.credentials.tin = data.info.tin;
                const type2Config = data.config.find(item => item.type === 2);
                if (type2Config) {
                    state.credentials.config = { status: type2Config.status };
                } else {
                    state.credentials.config = null;
                }
                that.account_number = state.credentials.account_no;
                that.full_name = state.credentials.name;
                that.gender = state.credentials.gender;
                that.Astatus = state.credentials.status;
                that.Membership = state.credentials.membership_type;
                that.Member_since = state.credentials.membership_date;
                that.email = state.credentials.email;
                that.mobile = state.credentials.mobile;
                that.tin = state.credentials.tin;
                that.age = state.credentials.age;
                that.birthdate = state.credentials.birthdate;
                that.serial = state.credentials.serial_no == null ? '??????' : state.credentials.serial_no;
                that.username = state.credentials.username;
                that.registered = state.credentials.registered_date;
                that.qr = data.qr;
                that.currentTin = state.credentials.tin;
                that.express = data.express;
                that.deactivated = data.deactivated;
                const rawRegisteredDate = state.credentials.registered_date;
                if (rawRegisteredDate) {
                    const parts = rawRegisteredDate.split('-');
                    that.registered = `${parts[1]}/${parts[2]}/${parts[0]}`;
                }

                const rawBirthdate = state.credentials.birthdate;
                if (rawBirthdate) {
                    const parts = rawBirthdate.split('-');
                    that.birthdate = `${parts[1]}/${parts[2]}/${parts[0]}`;
                }

                that.checkUserFlow();
                that.setLoading(false);

            }).catch(function (error) {
                that.error = true;
                that.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
                if (error.response.status == 403) {
                    that.expired = true
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.$store.state.logged = false;
                }
            });
        },
        checkUserFlow() {
            const that = this;
            const state = that.$store.state;
            const noContact = !state.credentials.mobile || !state.credentials.email;
            const config = state.credentials.config;
            const temporaryPIN = state.credentials.pin_update;
            const isValidated = that.$cookies.get('validated');

            this.getBanks();

            if (state.credentials.deactivated) {
                this.$router.push('/user/settings');
                return;
            }

            if (noContact) {
                state.credentials.noContact = noContact;
                this.show_update = true;
                return;
            }

            if (state.credentials.enrolled_pin) {
                const hasValidConfig = config && config.status;
                const noContact = state.credentials.noContact;
                state.credentials.enrolled_pin = false;

                if (noContact) {
                    that.show_update = false;
                    that.show_pin_modal = false;
                    that.show_otp_modal = false;
                    that.$cookies.set('validated', true);
                } else {
                    if (hasValidConfig) {
                        that.requestOTP();
                    } else {
                        that.show_update = false;
                        that.show_pin_modal = false;
                        that.show_otp_modal = false;
                        that.$cookies.set('validated', true);
                    }
                }
                return;
            }


            if (!isValidated) {
                if (state.credentials.has_pin) {
                    this.show_pin_modal = true;
                } else {
                    this.$router.push('/user/settings');
                }
            }

            if (temporaryPIN) {
                this.$router.push('/user/settings');
                state.credentials.edit_temporary = true;
                return;
            }

            const missingInfo = !state.credentials.mobile || !state.credentials.email ||
                !state.credentials.tin || !state.credentials.birthdate;

            if (missingInfo && !that.$cookies.get('skipped')) {
                this.show_update = true;
            }
        },
    },
})
</script>

<style scoped>
.max-width-back {
    max-width: 50px;
}
</style>
